export default {
  'time': {
    'firstTime': '',
    'secondTime': ''
  }
}
